<template>
  <div class='WidgetRede' :style="{ marginTop: top }">
    <div class="label" :style="{ color: color }">Nossas redes:</div>
    <div class="links">
      <div class="c-link">
        <enb-instagram @click="push(Empresa.instagram)"/>
      </div>
      <div class="c-link">
        <enb-facebook @click="push(Empresa.facebook)"/>
      </div>
      <div class="c-link">
        <enb-whatsapp @click="push(`https://wa.me/55${Empresa.whatsapp}`)"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EnbInstagram from './Instagram'
import EnbFacebook from './Facebook'
import EnbWhatsapp from './Whatsapp'
export default {
  name: 'WidgetRede',
  components: { EnbInstagram, EnbFacebook, EnbWhatsapp },
  computed: {
    ...mapGetters(['Empresa'])
  },
  props: {
    top: {
      type: String,
      default: '0px'
    },
    color: {
      type: String,
      default: '#000000'
    }
  },
  methods: {
    push (src) {
      window.location.replace(src)
    }
  }
}
</script>

<style scoped>
.WidgetRede {
  text-align: center;
}

.label {
  padding-bottom: 2px;
}

.links {
  display: flex;
  align-items: center;
  justify-content: center;
}

.c-link {
  padding: 5px;
}

</style>
